import {combineReducers} from 'redux';
import {Reducer} from "./spirs/reducer";
import {enableDefaultLineStep, enableDefaultLiveStep} from "./spirs/reducers/defaultStepsReducer";
import {appSettingsReducer} from "./spirs/reducers/appSettingsReducer";
import {StoreType} from "./spirs/types";
import {selectResultTab} from "./spirs/reducers/resultPageReducer";
import {loading} from "./spirs/reducers/loadingReducer";
import {view} from "./spirs/reducers/viewReducer";
import {mobileCouponModal} from "./spirs/reducers/mobileModalCouponReducer";
import {theme} from "./spirs/reducers/themeReducer";
import {loadedTree} from "./spirs/reducers/loadedTree";
import { treeType } from './spirs/reducers/changeTreeTypeReducer';

export const rootReducer = () => combineReducers<StoreType>({
    spirs: Reducer,
    appSettings: appSettingsReducer,
    enableDefaultLiveStep,
    enableDefaultLineStep,
    selectResultTab,
    loading,
    view,
    loadedTree,
    mobileCouponModal,
    theme,
    type: treeType
});
